const { $, Chart, rz } = window; // dict

// RZKIT-TABLE: chart.js
export default function rzkitchartupdate() {
  const elcanvas = $("canvas[eltype='chart']");
  if (!elcanvas || !elcanvas[0]) return;

  function renderMyChart(eljson) {
    // Получим значение из таблицы rzkit
    const items = [];
    $("table#rzkittable>tbody>tr[id^='rzkitrow-']").each((r, rr) => {
      const idm = ($(rr).attr("id")).split("-");
      const xv = ($(rr).find("#rzkitcol-" + idm[1] + "-" + eljson.data.tablefields.x).text()).trim();
      const yv = ($(rr).find("#rzkitcol-" + idm[1] + "-" + eljson.data.tablefields.y).text()).trim();
      items.push({x: xv, y: rz.strSearchNum(yv, 1, 2, true)});
    });
    // eslint-disable-next-line no-param-reassign
    eljson.settings.data.labels = items.map((vv) => vv.x);
    // eslint-disable-next-line no-param-reassign
    eljson.settings.data.datasets[0].data = items.map((vv) => vv.y);
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const myChart = new Chart(elcanvas[0], eljson.settings);
  }

  // Прочитаем настройки
  const settingsString = ($("#" + ($(elcanvas[0]).attr("id")) + "-params").html()).trim();
  if (settingsString === "") return;
  try {
    const eljson = JSON.parse(settingsString);
    renderMyChart(eljson);
  }
  catch (e) { rz.log(e) }
}
